export default __webpack_public_path__ + "static/media/IMG_1857.408da15d.JPG";